import React from 'react';
import { LogoImg } from './elements';
import { PageWrapper, Container } from '@Main/elements';
import { P, Span } from '@helpers';
import bg from '@static/about/sfx-bg_2.png';

export const CorePrincipe = ({t}) => {
    return (
      <PageWrapper darkMode={true} bgImage={bg} height="390px">
        <Container paddingTop='35px' marginLeft='102px' marginRight='35px'>
          <LogoImg/>
          <P weight='400' size='25px' height='30px' marginTop='30px'>{t("The core principle")}</P>
          <P weight='400' size='15px' height='30px' marginTop='40px' width="700px">
            <Span weight='500' size='15px' height='30px'>
              {t("Setting the end-user interests as the central pivot when developing a product of any type is the basis of the Soft-FX philosophy.")}
            </Span> {t("This principle makes Soft-FX something more than just a technology provider. We are a company with a rich history and strong work ethics.")}
          </P>
        </Container>
     </PageWrapper>
  );
};
